import ButtonRow from './ButtonRow'
import React from 'react'
import {CancelLink, SaveIconSubmitButton} from './SaveSubmitButton'
import ModalDialog from './ModalDialog'
import {resolveRoute} from '../helpers/ajax'


export type BookingConflict = {
    bookingId: number;
    segmentId: number;
    bookingNumber: number;
    confirmedDate: string;  // ISO timestamp
    pickupTime: string;     // Custom formatted date string
    dropoffTime: string;    // Custom formatted date string
    driverId: number | null;
    vehicleId: number;
    driverFirstName: string | null;
    driverLastName: string | null;
    vehicleName: string;
    vehicleCode: string;
    inputSegmentNumber: number;
    driverMatches: boolean;
    vehicleMatches: boolean;
};

export type BookingConflictsResponse = {
    conflicts: BookingConflict[]
}

type ConflictsDialogProps = {
    dontAssign: VoidFn
    assign: VoidFn
    conflicts: BookingConflict[]
}

export default function ConflictsDialog({
    dontAssign,
    assign,
    conflicts
}: ConflictsDialogProps) {
    return (
        <ModalDialog onClose={dontAssign} width="400px" title="Conflicts Found">
            <p className="error-text">Conflict with {conflicts.length} booking(s) found:</p>

            <ul className="conflicts-list">
                {conflicts.filter((c: any) => c.driverMatches).map((conflict: any) => <li
                    key={`${conflict.inputSegmentNumber}-${conflict.segmentId}-driver`}>S{conflict.inputSegmentNumber} Driver: <b>{conflict.driverFirstName} {conflict.driverLastName}</b> is
                    already scheduled {conflict.pickupTime}&ndash;{conflict.dropoffTime} (<a
                        href={resolveRoute('bookings.show', {id: conflict.bookingId})} target="_blank">Booking
                        #{conflict.bookingNumber} &ndash; {conflict.confirmedDate ? "CONFIRMED" : "QUOTE"}</a>)</li>)}

                {conflicts.filter((c: any) => c.vehicleMatches).map((conflict: any) => <li
                    key={`${conflict.inputSegmentNumber}-${conflict.segmentId}-vehicle`}>S{conflict.inputSegmentNumber} Vehicle: <b>{conflict.vehicleName} ({conflict.vehicleCode})</b> is
                    already scheduled {conflict.pickupTime}&ndash;{conflict.dropoffTime} (<a
                        href={resolveRoute('bookings.show', {id: conflict.bookingId})} target="_blank">Booking
                        #{conflict.bookingNumber} &ndash; {conflict.confirmedDate ? "CONFIRMED" : "QUOTE"}</a>)</li>)}

                {conflicts.filter((c: any) => c.vehicleDateBlocked).map((conflict: any, idx: any) => (
                    <li key={`vbd-${idx}`}>Segment {conflict.segNum}: <b>{conflict.vehicleName} ({conflict.vehicleCode})</b> is
                        scheduled off {conflict.dateRange} due to <b>{conflict.reason}</b></li>
                ))}

                {conflicts.filter((c: any) => c.userDateBlocked).map((conflict: any, idx: any) => (
                    <li key={`vbd-${idx}`}>Segment {conflict.segNum}: <b>{conflict.driverName}</b> is scheduled
                        off {conflict.dateRange} due to <b>{conflict.reason}</b></li>
                ))}
            </ul>

            <ButtonRow>
                <ButtonRow.Left/>
                <ButtonRow.Right>
                    <SaveIconSubmitButton type="button" onClick={assign}>Assign Anyways</SaveIconSubmitButton>
                    <CancelLink onClick={dontAssign}>Don't Assign</CancelLink>
                </ButtonRow.Right>
            </ButtonRow>
        </ModalDialog>
    )
}
